import React, {useState, useEffect, Fragment} from "react";
import styled from "styled-components";
import PullToRefresh from "react-simple-pull-to-refresh";
import {useLocation, useNavigate, useParams} from "react-router";
import {useSelector} from "react-redux";

import {api} from "utils";
import {getCommaNumber} from "utils/format";

import MainLayout from "layouts/MainLayout";
import Button from "components/ui/Button";
import Badge from "components/ui/Badge";
import PassInfo from "./PassInfo";
import PaymentForm from "./PaymentForm";
import PullToRefreshing from "components/common/PullToRefreshing";
import {getServiceTypeColor, getServiceTypeName} from "../../../utils/define";



/**
 * [환불 결제 상세]
 */

export const RefundInfo = (props) => {
	const navigate = useNavigate();
	const location = useLocation()
	const {seqRefundInfo} = useParams();
	const {serviceType} = location.state || {};

	const [data, setData] = useState({});
	const [isLoading, setLoading] = useState(true);
	const [isError, setError] = useState(false);

	useEffect(() => {
		eventHandler.update();
	}, [seqRefundInfo]);

	const eventHandler = {
		update : () => {
			api.get("/sales/refund/details/" + seqRefundInfo).then(({data}) => {
				setData(data || {});
			}).catch(error => {
				setError(true);
			}).finally(() => {
				setLoading(false);
			});
		},
		toggleDrop : (event) => {
			const target = event.currentTarget;
			target.classList.toggle("focus");
		},
		pullToRefresh: () => {
			return new Promise((resolve) => {
				setTimeout(() => {
					eventHandler.update();
					resolve();
				}, 700);
			});
		}
	};

	const render = () => {
		const getTitle = () => {
			const orderPayType = (data.webAppDiv == "A") ? "b.pay" : "현장판매";
			const orderName = (data.orderName || "(이름없음)").recoverTag();
			const serviceTypeName = getServiceTypeName(serviceType);
			const serviceTypeColor = getServiceTypeColor(serviceType);
			return (
				<div className="title">
					{
						(serviceType) ?
							<h5 className={serviceTypeColor}>{serviceTypeName}</h5> :
							<h5 className="blue">{orderPayType}</h5>
					}
					<h2>{orderName}</h2>
				</div>
			);
		};

		const getRefundInfo = () => {
			const refundDateTime = new Date(data.refundDateTime || data.orderDateTime).format("yyyy. sm. sd. sw · hh:MM:ss");
			const refundPaymentInfo = {
				cancelAmount : 0,
				refundAmount : 0,
				paymentAmount : 0
			};
			(data.refundPayments || []).forEach(item => {
				if(item.refundPaymentType == "PAYMENT") {
					refundPaymentInfo.paymentAmount += item.paymentAmount || 0;
				} else {
					if(item.paymentType == "CARD") {
						refundPaymentInfo.cancelAmount += item.refundAmount || 0;
					} else {
						refundPaymentInfo.refundAmount += item.refundAmount || 0;
					}
				}
			});

			const getPaymentType = () => {
				const typeList = ["현금", "카드취소", "현금 + 카드취소"];
				const isCash = (refundPaymentInfo.refundAmount);
				const isCard = (refundPaymentInfo.cancelAmount);
				const typeName = (isCash && isCard) ? typeList[2] : (isCard) ? typeList[1] : typeList[0];
				return (<Badge color="red">{typeName}</Badge>);
			};

			// <div>총 환불지급액</div>
			// <div className="drop" onClick={eventHandler.toggleDrop}> ... </div>
			return (
				<div className="refundInfo">
					<h4>환불 정보</h4>
					<ul>
						<li><div>환불일시</div><div>{refundDateTime}</div></li>
						<li><div>결제분류</div><div><Badge color="red">환불</Badge></div></li>
						<li><div>환불금액</div><div>{getCommaNumber((data.refundAmount || 0) * -1)}원</div></li>
						<li><div>위약금</div><div>{getCommaNumber(data.refundPenalty)}원</div></li>
						<li>
							<div>총 환불지급액</div>
							<div className="drop" onClick={eventHandler.toggleDrop}>
								<b className="red">{getCommaNumber((data.refundPayment || 0) * -1)}원</b>
							</div>
							<ul>
								<li><div>카드취소</div><div>{getCommaNumber((refundPaymentInfo.cancelAmount || 0) * -1)}원</div></li>
								<li><div>현금환불</div><div>{getCommaNumber((refundPaymentInfo.refundAmount || 0) * -1)}원</div></li>
								<li><div>환불재결제</div><div>{getCommaNumber(refundPaymentInfo.paymentAmount)}원</div></li>
							</ul>
						</li>
						<li><div>회원명</div><div>{data.memberName}</div></li>
						<li><div>환불 담당자</div><div>{data.coachName}</div></li>
					</ul>
				</div>
			);
		};

		return (
			<PullToRefresh
				onRefresh={eventHandler.pullToRefresh}
				resistance={2}
				pullingContent={<></>}
				refreshingContent={<PullToRefreshing />}
			>
				<MainLayout
					withHeader={true}
					headerProps={{
						withBackButton : true,
						centerTitle : "상세 내역"
					}}
					backgroundColor="white"
					withBottomTab={false}
					isLoading={isLoading}
					isError={isError}
				>
					<PaymentForm>
						<div className="color">
							{getTitle()}
							{getRefundInfo()}
							<PassInfo data={data} />
						</div>
						<Button color="blue" onClick={() => {navigate(-1)}}>확인</Button>
					</PaymentForm>
				</MainLayout>
			</PullToRefresh>
		);
	};
	return render();
};

export default RefundInfo;